/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import PaymentStep from '../PaymentStep';
import apiCalls from '../../../PowerShadesAPIFunctions';

const DealerTermsPayment = ({
	setProcessing,
	willNeedRetainer,
	setSubmit,
	showSubmit,
	halfPrice,
	quote
}) => {
	const [, setWaiting] = useState<null | boolean>(false);
	const [poNumber, setPoNumber] = useState<null | string>(null);
	const [, setError] = useState<null | string>(null);

	const referenceNumber = quote.reference_number;

	const quoteId = quote.id;

	const isEmptyOrSpaces = (str: string | null) => str === null || str.toString().trim() === '';

	const placeHolder = isEmptyOrSpaces(referenceNumber) ? `PS${quoteId}` : referenceNumber;

	const submit = () => {
		setWaiting(true);

		setProcessing(true);

		const po = isEmptyOrSpaces(poNumber) ? placeHolder : poNumber;

		return new Promise((resolve, reject) => {
			apiCalls.submitDealerTermsPayment(quoteId, po).then((resp) => {
				const data = resp?.data;

				const success = data?.success;

				if (success) {
					resolve('Payment successful.');
				} else {
					const errorMessage = data?.error ?? 'Something went wrong.';
					console.error(resp);
					Sentry.captureException(Error(errorMessage));
					reject(errorMessage);
					setWaiting(false);
					setError(errorMessage);
				}
			});
		});
	};

	useEffect(() => {
		setSubmit(() => submit());
		showSubmit();
	}, []);

	return (
		<div>
			<div>
				Please enter PO number:
			</div>
			<input
				type="text"
				onChange={(e) => setPoNumber(e.target.value)}
				placeholder={placeHolder}
				value={poNumber || ''}
			/>
			{willNeedRetainer ? (
				<div>
					{`This order will require a retainer equal to $${halfPrice} to be paid before the shades are made.`}
				</div>
			) : null}
			<PaymentStep />
		</div>
	);
};

export default DealerTermsPayment;
